<div class="patient__form--header">
  <div class="patient__form--header--text">
    <span app-badge color="primary" appearance="tonal" size="lg">
      <span app-badge-content>
        <i class="icon--user-plus icon--lg"></i>
      </span>
    </span>
    <div class="header-label">
      <span class="header-title">Cadastrar cliente</span>
      <span class="header-sub-text">Caso não possua e-mail, utilize o do contratante</span>
    </div>
  </div>

  <button app-button color="neutral" appearance="tonal" (click)="closeModal()">
    <span app-button-content>
      <i class="icon--close icon--md"></i>
    </span>
  </button>
</div>

<div class="patient__form--body">
  <form [formGroup]="patientForm" [class.disable-form]="isFormDisabled">
    <div class="personal__details">
      <div class="section__divider">
        <span app-badge color="primary" appearance="tonal" size="md">
          <span app-badge-content>
            <fa-icon icon="user" style="font-size: 12px"></fa-icon>
          </span>
        </span>
        <span>Dados pessoais</span>
      </div>

      <div class="app-grid--box">
        <app-form-field [control]="patientFormControl.patientCpf" fieldName="CPF">
          <label>CPF do cliente</label>
          <input
            app-input
            formControlName="patientCpf"
            placeholder="000.000.000-00"
            mask="000.000.000-00"
          />
        </app-form-field>

        <app-form-field
          [control]="patientFormControl.patientName"
          fieldName="Nome do cliente"
          maxlength="100"
        >
          <label>Nome completo do cliente</label>
          <input app-input formControlName="patientName" placeholder="Nome do cliente" />
        </app-form-field>

        <app-form-field
          [control]="patientFormControl.patientBirthdate"
          fieldName="Data de nascimento"
        >
          <label>Data de nascimento</label>
          <input
            app-input
            formControlName="patientBirthdate"
            placeholder="DD/MM/AAAA"
            mask="00/00/0000"
          />
        </app-form-field>

        <app-form-field [control]="patientFormControl.patientMobile">
          <label>Whatsapp do cliente</label>
          <input
            app-input
            formControlName="patientMobile"
            placeholder="(00) 00000-0000"
            mask="(00) 00000-0000"
          />
        </app-form-field>
      </div>

      <div>
        <app-form-field [control]="patientFormControl.patientEmail" fieldName="Email">
          <label>E-mail do cliente</label>
          <input app-input formControlName="patientEmail" placeholder="email@exemplo.com" />
        </app-form-field>
      </div>
    </div>

    <div class="address__details" formGroupName="address">
      <div class="section__divider">
        <span app-badge color="info" appearance="tonal" size="md">
          <span app-badge-content>
            <fa-icon icon="map-marked" style="font-size: 12px"></fa-icon>
          </span>
        </span>
        <div class="section__divider--badge">
          <span>Endereço</span>
          <span app-badge color="neutral" appearance="tonal" size="xs"> opcional </span>
        </div>
      </div>

      <div class="app-grid--box">
        <div class="form__field__box">
          <app-form-field>
            <label>CEP</label>
            <input app-input formControlName="cep" placeholder="00000-000" mask="00000-000" />
          </app-form-field>
          <span class="form__field__box--error" *ngIf="showErrorCep"
            >Não foi possível encontrar o endereço.</span
          >
        </div>

        <app-form-field>
          <label>ESTADO </label>
          <input app-input formControlName="state" placeholder="Ex: SP" />
        </app-form-field>

        <app-form-field>
          <label>Município</label>
          <input app-input formControlName="city" placeholder="Ex: São Paulo" />
        </app-form-field>

        <app-form-field [control]="addressFormControl.neighborhood" fieldName="Bairro">
          <label>Bairro</label>
          <input app-input formControlName="neighborhood" placeholder="Ex: Centro" />
        </app-form-field>
      </div>

      <app-form-field [control]="addressFormControl.address" fieldName="Logradouro">
        <label>Logradouro</label>
        <input app-input formControlName="address" placeholder="Rua, Avenida..." />
      </app-form-field>

      <div class="app-grid--box app-grid--box--number">
        <app-form-field [control]="addressFormControl.number" fieldName="Número">
          <label>Número</label>
          <input app-input formControlName="number" placeholder="Ex: 42" />
        </app-form-field>

        <app-form-field>
          <label>Complemento</label>
          <input app-input formControlName="complement" placeholder="Apto, Bloco..." />
        </app-form-field>
      </div>
    </div>

    <div class="representative__box">
      <div class="section__divider">
        <span app-badge color="contrast" appearance="tonal" size="md">
          <span app-badge-content>
            <fa-icon icon="user-shield" style="font-size: 12px"></fa-icon>
          </span>
        </span>
        <span>Responsável legal</span>
      </div>

      <div class="switch__badge" [ngClass]="hasRepresentative ? 'switch__badge--active' : ''">
        <div class="switch__badge--text">
          <div class="switch__badge--title">
            <fa-icon icon="gavel" class="switch__badge--icon"></fa-icon>
            Possui representante legal ou responsável autorizado?
          </div>
          <div class="switch__badge--sub-text">
            <span>Ative quando o cliente não puder responder por si ou tiver representante formal.</span>
          </div>
        </div>

        <app-switch-button
          color="contrast"
          formControlName="hasLegalRepresentative"
          [disabled]="disableToggleRepresentative"
        ></app-switch-button>
      </div>

      <div class="representative__details" formGroupName="representative" *ngIf="hasRepresentative">
        <app-form-field
          [control]="representativeFormControl.representativeName"
          fieldName="Nome do responsável"
        >
          <label>Nome completo do responsável</label>
          <input
            app-input
            formControlName="representativeName"
            placeholder="Nome completo do responsável"
          />
        </app-form-field>

        <div class="app-grid--box">
          <app-form-field
            [control]="representativeFormControl.representativeCpf"
            fieldName="CPF do responsável"
          >
            <label>CPF do reponsável</label>
            <input
              app-input
              formControlName="representativeCpf"
              placeholder="000.000.000-00"
              mask="000.000.000-00"
            />
          </app-form-field>

          <app-form-field
            [control]="representativeFormControl.representativeRelationship"
            fieldName="Grau de parentesco"
          >
            <label>Grau de parentesco</label>
            <app-select formControlName="representativeRelationship">
              <app-option *ngFor="let option of getRelationshipOptions()" [value]="option">
                {{ option }}
              </app-option>
            </app-select>
          </app-form-field>

          <app-form-field
            [control]="representativeFormControl.representativeMobile"
            fieldName="Telefone do responsável"
          >
            <label>Telefone do responsável</label>
            <input
              app-input
              formControlName="representativeMobile"
              placeholder="(00)00000-0000"
              mask="(00)00000-0000"
            />
          </app-form-field>

          <app-form-field>
            <label
              >E-mail do responsável
              <span app-badge color="neutral" appearance="tonal" size="xs"> opcional </span>
            </label>
            <input
              app-input
              formControlName="representativeEmail"
              placeholder="email@exemplo.com"
            />
          </app-form-field>
        </div>
      </div>
    </div>
  </form>
</div>
<div class="patient__form--actions">
  <button app-button color="neutral" appearance="tonal" (click)="closeModal()">Cancelar</button>

  <button
    app-button
    color="primary"
    appearance="filled"
    type="submit"
    [disabled]="!patientForm.valid || isLoadingCep"
    (click)="onPatientFormSubmit()"
  >
    <span>Salvar</span>
  </button>
</div>
